import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  EVENT: {
    GET_RECOMMENDED: (query) => ({ query }),
    API: {
      GET_RECOMMENDED: apiResourceActionCreator('recommendedResult')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/recommended${endpointQuery({ ...(query || {}) })}`, authToken, action.event.api.getRecommended)

function* getRecommended({ payload }) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, payload && payload.query));
}

const configuration = {
  name: 'getRecommended',
  action: action,
  sagas: getRecommended,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      recommendedEventResult: action.payload.recommendedResult,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      isLoadingMore: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/event/configurations/getRecommended.js